export default "__VITE_ASSET__DqBytUKY__"